@if (display) {
	<p-dialog
		header="{{ title }}"
		[(visible)]="display"
		[transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
		[modal]="true"
		[style]="{ width: '480px' }"
	>
		<div class="ui-grid ui-grid-responsive ui-fluid">
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					@for (msg of messages; track msg) {
						<p-message [severity]="msg.severity" [text]="msg.detail"></p-message>
					}
				</div>
			</div>
			<div class="container">
				<!-- NAME -->
				<div class="row mt-3">
					<div class="col d-flex align-items-center">
						<label for="fineStatus-name" class="custom-label" i18n>
							{{ 'tableManagement.vehicleStatus.form.name' | translate }}
						</label>
					</div>
					<div class="col">
						<div class="float-end">
							<input type="text" id="name" class="form-control custom-input" style="width: 240px" [(ngModel)]="entity.name" />
						</div>
					</div>
				</div>
				<!-- DESCRIPTION -->
				<div class="row mt-3">
					<div class="col d-flex align-items-center">
						<label for="fineStatus-name" class="custom-label" i18n>
							{{ 'general.description' | translate }}
						</label>
					</div>
					<div class="col">
						<div class="float-end">
							<input
								type="text"
								id="description"
								class="form-control custom-input"
								style="width: 240px"
								[(ngModel)]="entity.description"
							/>
						</div>
					</div>
				</div>
				<!-- OBSERVATIONS -->
				<div class="row mt-3">
					<div class="col d-flex align-items-center">
						<label for="fineStatus-name" class="custom-label" i18n>
							{{ 'general.observations' | translate }}
						</label>
					</div>
					<div class="col">
						<div class="float-end">
							<input
								type="text"
								id="observations"
								class="form-control custom-input"
								style="width: 240px"
								[(ngModel)]="entity.observations"
							/>
						</div>
					</div>
				</div>
				<!-- ENABLED -->
				<div class="row mt-3 mb-3">
					<div class="col-6 d-flex align-items-center">
						<label for="fineStatus-enabled" class="custom-label" i18n>
							{{ 'control-panel.poi-categories.poiEnabled' | translate }}
						</label>
					</div>
					<div class="col">
						<div class="float-end">
							<input
								class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
								type="checkbox"
								[(ngModel)]="entity.enabled"
								disabled="true"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- PERIODICITY TYPE -->
			<div class="row mt-3 mb-3">
				<div class="col d-flex align-items-center">
					<label for="fineStatus-enabled" class="custom-label" i18n>
						{{ 'control-panel.maintenance-plans.periodicity' | translate }}
					</label>
				</div>
				<div class="col">
					<div class="d-flex justify-content-end gap-3">
						<div class="d-flex align-items-center gap-2">
							<p-radioButton
								inputId="periodicityTypeTime"
								name="groupname"
								value="TIME_BASED"
								[(ngModel)]="entity.periodicityType"
							></p-radioButton>
							<label for="periodicityTypeTime" i18n>{{ 'control-panel.maintenance-plans.time' | translate }}</label>
						</div>
						<div class="d-flex align-items-center gap-2">
							<p-radioButton
								inputId="periodicityTypeKms"
								name="groupname"
								value="DISTANCE_BASED"
								[(ngModel)]="entity.periodicityType"
							></p-radioButton>
							<label for="periodicityTypeKms" i18n>{{ 'control-panel.maintenance-plans.kms' | translate }}</label>
						</div>
						<div class="d-flex align-items-center gap-2">
							<p-radioButton
								inputId="periodicityTypeUsage"
								name="groupname"
								value="HOURS_BASED"
								[(ngModel)]="entity.periodicityType"
							></p-radioButton>
							<label for="periodicityTypeUsage" i18n>{{ 'control-panel.maintenance-plans.usage' | translate }}</label>
						</div>
					</div>
				</div>
			</div>
			@if (this.entity.periodicityType === 'TIME_BASED') {
				<div>
					<!-- PERIODICITY -->
					<div class="row mt-4">
						<div class="col d-flex align-items-center">
							<label for="fineStatus-name" class="custom-label" i18n>
								{{ 'control-panel.maintenance-plans.periodicity' | translate }}
								{{ 'control-panel.maintenance-plans.time' | translate }}
							</label>
						</div>
						<div class="col d-flex justify-content-end align-items-center gap-2" style="width: 240px">
							<p-inputNumber
								[(ngModel)]="entity.periodicity"
								[showButtons]="true"
								[step]="1"
								[inputStyle]="{ width: '100px' }"
							></p-inputNumber>
							<p-select
								[options]="periodicityTimeUnitOptions"
								[(ngModel)]="entity.periodicityTimeUnit"
								(onChange)="onTimeUnitChange($event)"
								[style]="{ width: '130px' }"
								appendTo="body"
							></p-select>
						</div>
					</div>
					<!-- NOTIFY BEFORE -->
					<div class="row mt-3">
						<div class="col d-flex align-items-center">
							<label for="fineStatus-name" class="custom-label" i18n>
								{{ 'control-panel.maintenance-plans.notifyBefore' | translate }} ({{ notifyBeforeTimeString }})
							</label>
						</div>
						<div class="col">
							<div class="float-end">
								<p-inputNumber
									[(ngModel)]="entity.notifyBefore"
									[showButtons]="true"
									[step]="1"
									[min]="0"
									[max]="365"
									[inputStyle]="{ width: '240px' }"
								></p-inputNumber>
							</div>
						</div>
					</div>
				</div>
			}
			@if (this.entity.periodicityType === 'DISTANCE_BASED') {
				<div>
					<!-- PERIODICITY -->
					<div class="row mt-4">
						<div class="col d-flex align-items-center">
							<label for="fineStatus-name" class="custom-label" i18n>
								{{ 'control-panel.maintenance-plans.periodicity' | translate }}
								{{ 'control-panel.maintenance-plans.kms' | translate }}
							</label>
						</div>
						<div class="col">
							<div class="float-end">
								<p-inputNumber
									[(ngModel)]="entity.periodicity"
									[showButtons]="true"
									[inputStyle]="{ width: '240px' }"
								></p-inputNumber>
							</div>
						</div>
					</div>
					<!-- NOTIFY BEFORE -->
					<div class="row mt-3">
						<div class="col d-flex align-items-center">
							<label for="fineStatus-name" class="custom-label" i18n>
								{{ 'control-panel.maintenance-plans.notifyBefore' | translate }} ({{
									'control-panel.maintenance-plans.kms' | translate
								}})
							</label>
						</div>
						<div class="col">
							<div class="float-end">
								<p-inputNumber
									[(ngModel)]="entity.notifyBefore"
									[showButtons]="true"
									[inputStyle]="{ width: '240px' }"
								></p-inputNumber>
							</div>
						</div>
					</div>
				</div>
			}
		</div>

		@if (this.entity.periodicityType === 'HOURS_BASED') {
			<div>
				<!-- PERIODICITY HOURS -->
				<div class="row mt-4">
					<div class="col d-flex align-items-center">
						<label for="fineStatus-name" class="custom-label" i18n>
							{{ 'control-panel.maintenance-plans.periodicity' | translate }} ({{
								'control-panel.maintenance-plans.hours' | translate
							}})
						</label>
					</div>
					<div class="col">
						<div class="float-end">
							<p-inputNumber
								[(ngModel)]="entity.periodicity"
								[showButtons]="true"
								[inputStyle]="{ width: '240px' }"
							></p-inputNumber>
						</div>
					</div>
				</div>
				<!-- NOTIFY BEFORE HOURS -->
				<div class="row mt-3">
					<div class="col d-flex align-items-center">
						<label for="fineStatus-name" class="custom-label" i18n>
							{{ 'control-panel.maintenance-plans.notifyBefore' | translate }} ({{
								'control-panel.maintenance-plans.hours' | translate
							}})
						</label>
					</div>
					<div class="col">
						<div class="float-end">
							<p-inputNumber
								[(ngModel)]="entity.notifyBefore"
								[showButtons]="true"
								[inputStyle]="{ width: '240px' }"
							></p-inputNumber>
						</div>
					</div>
				</div>
			</div>
		}

		<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
					@if (isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" i18n>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
				</div>
				<div class="p-2 bd-highlight">
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="changeStatus(!entity.enabled)" i18n>
								{{ 'general.changeStatus' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
	</p-dialog>
}
